<template>
    <div>
      <SelectSearch
        :value="selectedStudents"
        @input="selectStudents"
        :options="options"
        :optionLabel="'displayname'"
        :nullLabel="`${selectedStudents.length} ${$t('students-selected')}`"
        class="border rounded p-2 my-2 mb-2"
        :showStudentIds="showStudentIds"
      />
  
      <GroupMultiSelect
        v-if="allGroups.length"
        :value="selectedGroups"
        :groups="allGroups"
        @input="updateSelectedGroups"
        @active-programme="selectedProgramme"
      />
      <template v-if="activeProgramme">
        <div
            v-for="(years, programmeId) in allStudentsByGroup"
            :key="programmeId"
            class="row"
        > 
            <template v-if="programmeId == activeProgramme">
                <template v-for="(groups, year) in years">
                    <template v-for="(users, groupId) in groups">
                        <div
                            v-if="isGroupSelected(activeProgramme, year, groupId)"
                            :key="`${activeProgramme}-${year}-${groupId}`"
                            class="col-12 col-xl-6 col-xxl-4"
                        > 
                        <UserSelector
                            :value="selectedStudentsByGroup[activeProgramme][year][groupId]"
                            @input="val => updateSelectedStudents(val,activeProgramme, year, groupId)"
                            :users="users"
                            :label="$t('year')+' '+year+', '+$t('group')+' '+$config.getValue('groups')[groupId]"
                            class="border rounded p-2 my-2"
                            :showStudentIds="showStudentIds"
                        />
                        </div>
                    </template>
                </template>
            </template>
        </div>
      </template>
    </div>
  </template>
  
  <script>
  import UserSelector from '../Users/UserSelector.vue';
  import GroupMultiSelect from '../ProgrammeYearGroups/GroupMultiSelect.vue';
  import SelectSearch from '../Inputs/SelectSearch.vue';
  
  export default {
    components: {
      UserSelector,
      GroupMultiSelect,
      SelectSearch
    },
    props: {
      value: {
        type: Array,
        default: () => []
      },
      options: {
        type: Array,
        default: () => []
      },
      showStudentIds: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        selectedStudents: [],//this.value,
        allGroups: [],
        selectedGroups: [],
        allStudentsByGroup: {},
        selectedStudentsByGroup: {},
        activeProgramme: null
      };
    },
    mounted() {
      this.sortStudents(this.options, this.selectedStudents);
    },
    created() {
        // Initial sync
        this.handleValueChange(this.value);
    },
    methods: {
        handleValueChange(newVal) {
            // avoid infinite loop
            if (newVal === this.selectedStudents) return;

            this.selectedStudents = newVal;
            this.$nextTick(() => {
                if (this.options.length > 0) {
                    this.sortStudents(this.options, newVal);
                }
            });
        },
      sortStudents(allStudents, selectedStudents) {
        this.allStudentsByGroup = {};
        this.selectedStudentsByGroup = {};
  
        const studentsByIndex = allStudents.reduce((prev, curr) => {
          prev[curr.id] = curr;
          return prev;
        }, {});
  
        selectedStudents = selectedStudents
          .map(student => studentsByIndex[student.id])
          .filter(student => !!student);
  
        this.allGroups = [];
  
        allStudents.forEach(student => {
          const { programme_id, year, group_id } = student;
  
          if (!this.allStudentsByGroup[programme_id]) {
            this.$set(this.allStudentsByGroup, programme_id, {});
            this.$set(this.selectedStudentsByGroup, programme_id, {});
          }
          if (!this.allStudentsByGroup[programme_id][year]) {
            this.$set(this.allStudentsByGroup[programme_id], year, {});
            this.$set(this.selectedStudentsByGroup[programme_id], year, {});
          }
          if (!this.allStudentsByGroup[programme_id][year][group_id]) {
            this.allGroups.push({ programme_id, year, group_id });
            this.$set(this.allStudentsByGroup[programme_id][year], group_id, []);
            this.$set(this.selectedStudentsByGroup[programme_id][year], group_id, []);
          }
  
          this.allStudentsByGroup[programme_id][year][group_id].push(student);
  
          if (selectedStudents.find(s => s.id === student.id)) {
            this.selectedStudentsByGroup[programme_id][year][group_id].push(student);
          }
        });
  
        this.selectedGroups = this.getStudentGroups(selectedStudents);
        this.selectedStudents = this.getSelectedStudents();
      },
      selectedProgramme(newProgramme){
        this.activeProgramme = newProgramme
      },
      updateSelectedGroups(newGroups) {
        const key = gr => `${gr.programme_id}-${gr.year}-${gr.group_id}`;
  
        const newKeys = newGroups.map(key);
        const oldKeys = this.selectedGroups.map(key);
  
        newGroups.forEach(gr => {
          if (!oldKeys.includes(key(gr))) {
            this.selectedStudentsByGroup[gr.programme_id][gr.year][gr.group_id] = [
              ...this.allStudentsByGroup[gr.programme_id][gr.year][gr.group_id]
            ];
          }
        });
  
        this.selectedGroups.forEach(gr => {
          if (!newKeys.includes(key(gr))) {
            this.selectedStudentsByGroup[gr.programme_id][gr.year][gr.group_id] = [];
          }
        });
  
        this.selectedGroups = newGroups;
        this.selectedStudents = this.getSelectedStudents();
      },
      updateSelectedStudents(students, programmeId, year, groupId) {
        this.selectedStudentsByGroup[programmeId][year][groupId] = students;
        this.selectedStudents = this.getSelectedStudents();
      },
      selectStudents(students) {
        this.sortStudents(this.options, students);
      },
      getSelectedStudents() {
        const students = [];
        Object.values(this.selectedStudentsByGroup).forEach(programme =>
          Object.values(programme).forEach(year =>
            Object.values(year).forEach(group => {
              students.push(...group);
            })
          )
        );
        return students;
      },
      getStudentGroups(students) {
        const groups = {};
        students.forEach(student => {
          const key = `${student.programme_id}-${student.year}-${student.group_id}`;
          groups[key] = {
            programme_id: student.programme_id,
            year: student.year,
            group_id: student.group_id
          };
        });
        return Object.values(groups);
      },
      isGroupSelected(programmeId, year, groupId) {
        return this.selectedGroups.findIndex(
          el => el.programme_id === programmeId && el.year === year && el.group_id === groupId
        ) > -1;
      },
    },
    watch: {
    //   selectedStudents(newVal) {
    //     this.$emit('input', newVal);
    //   }
    value: {
      handler(newVal) {
        this.handleValueChange(newVal);
      },
      immediate: false // we handled initial in `created`
    },
    selectedStudents(newVal) {
      // Only emit if different from prop (avoid feedback loop)
      if (newVal !== this.value) {
        this.$emit('input', newVal);
      }
    },
    options: {
      handler(newOptions) {
        // If options load later, re-sort
        if (newOptions.length > 0 && this.value) {
          this.sortStudents(newOptions, this.value);
        }
      },
      immediate: false
    }
    }
  };
  </script>